import { render, staticRenderFns } from "./AdminConnectorDetailsPage.vue?vue&type=template&id=5371561e"
import script from "./AdminConnectorDetailsPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdminConnectorDetailsPage.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports